import { render, staticRenderFns } from "./topWastedCategories.vue?vue&type=template&id=0c57ff4b"
import script from "./topWastedCategories.js?vue&type=script&lang=js&external"
export * from "./topWastedCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports